
import { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Swiper, Image, List, Popover, PopoverInstance } from 'react-vant';
import nftImg from "@/assets/images/newNfted.png"
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import Back from "../../../components/common/BackComp";
import ButtonComp from "../../../components/common/ButtonComp";
import loading from '@/assets/images/cards/loading.png'
import { getCharactersList, getSetting, getSearchHistory, deleteSearchHistory, getAvatarCommercial, postAvatarCommercial, postSetting, getUserInfo, getCurrentAvatarLanguage, getAvatarTags } from "@/api/url.js"
import { pushChatListId, setCurrAvatarId, setCurrCharacterInfo } from '../../../store/module/progress';
import { changeCharacterList, changeUserInfo } from '../../../store/module/tabbar';
import PromptDialog from '../../../components/PromptDialog';
import { attributeImage, FormattingNumber } from '../../../utils';
import { changeSettings } from '../../../store/module/settins';
import Logs from '../Logs';
import show from '@/assets/images/cards/show.svg'

import { postWarningInformation } from "@/api/url.js"
import GlassmorphismCanvas from '../../../hook/useBlur';
import { useTranslation } from 'react-i18next';
// import { changeActive } from '../../store/module/search';
// import Sale from "../cards/Sale";
// import { formatNumber } from "../../utils/index.js";
// import Main from "../cards/Main.js";
// import Back from "../../components/common/BackComp.js";
// import ButtonComp from "../../components/common/ButtonComp.js";
// import NumberKeyBoard from "../../components/NumberKeyBoard.js";

const Search = () => {
    const { t } = useTranslation();
    const pageSize = 10
    const total = useRef(0);
    const currPage = useRef(1)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const isInitLoading = useRef(true)
    const roleRef = useRef<any>(null);
    const [params] = useSearchParams();
    const [value, setValue] = useState('')
    const [searchParams] = useSearchParams()
    const [text, setText] = useState<any>('')
    const popover = useRef<PopoverInstance>(null)
    const [promptText, setPromptText] = useState<any>('')
    const [dialog, setDialog] = useState(false)
    const settings = useSelector((state: any) => state.settings.settings)
    const ID: string | null = params.get("id")
    const [delDialog, setDelDialog] = useState(false)
    const [payDialog, setPayDialog] = useState(false)
    const [finished, setFinished] = useState(false);
    const [coin_NSFW, setCoin_NSFW] = useState(false)
    const [isLoading, setIsLoading] = useState<any>(false)
    const [isFocus, setIsFocus] = useState<any>(false)
    const [dataList, setDataList] = useState<Array<any>>([])
    const [searchHistory, setSearchHistory] = useState<Array<any>>([])
    const [tags, setTags] = useState<Array<any>>([])
    const chatMessageList = useSelector((state: any) => state.progress.chatList)
    const [ids, setIds] = useState<any>([])
    const [logsValue, setLogsValue] = useState("")
    const [starType, setStateType] = useState<any>("")


    const searchHandle = (e: any) => {
        currPage.current = 1
        setValue(e.target.value)
        if (!e) {
            setDataList([])
        }
    }

    const history = async () => {
        const { code, data } = await getSearchHistory()
        if (code == '0') {
            setSearchHistory(data)
        }
    }
    const avatarTags = async () => {
        const { code, data } = await getAvatarTags()
        if (code == '0') {
            setTags(data.tags)
        }
    }
    useEffect(() => {
        avatarTags()
    }, [])
    //清除输入框
    const clearHandle = () => {
        setValue('')
    }

    useEffect(() => {
        const ids: any = dataList.length && dataList.map((item: any) => item.id)
        setIds(ids)
        const listId = chatMessageList.map((item: any) => item.id)
        for (let i = 0; i < ids.length; i++) {
            if (!listId.includes(ids[i])) {
                dispatch(pushChatListId({ id: ids[i], list: [], actionList: [] }))
            }
        }

    }, [dataList])

    //go to talk page logic handler
    const goToTalkPage = async (currCharacterInfo: any) => {
        if (!chatMessageList.length) {
            for (let i = 0; i < ids.length; i++) {
                dispatch(pushChatListId({ id: ids[i], list: [], actionList: [] }))
            }
        }
        //缓存
        dispatch(setCurrCharacterInfo(currCharacterInfo))
        window.localStorage.setItem("currCharacterInfo", JSON.stringify(currCharacterInfo));
        dispatch(setCurrAvatarId(currCharacterInfo.id))
        const language = await getCurrentLanguage(currCharacterInfo.id)
        //跳转到聊天页
        setTimeout(() => {
            navigate(`/agent?id=${currCharacterInfo.id}&language=${language}`);
        }, 200);

    }
    //get current avatar language
    const getCurrentLanguage = async (id: string) => {
        console.log(id)
        try {
            const { code, data } = await getCurrentAvatarLanguage(id)
            if (code == 0) {
                return data
            }
        } catch (e) {
            console.log("🚀 ~ getCurrentLanguage ~ e:", e)
        }
    }
    //run nsfw logic handler
    const nsfwHandle = async (currCharacterInfo: any) => {
        try {
            let ID =  window.localStorage.getItem("userId") || "";
            
            const { code, data } = await getSetting(ID)
            // console.log(res)
            if (code == 0) {
                if (data.character_nsfw) {
                    await goToTalkPage(currCharacterInfo)
                } else {
                    setStateType({ character_nsfw: true })
                    setCoin_NSFW(true)
                }
            }
        } catch (e) {
            console.log(e)
        }

    }


    const [payData, setPayData] = useState<any>(null)

    const goToTalk = async (currCharacterInfo: any) => {
        setPayData(currCharacterInfo)
        if (currCharacterInfo.is_my) {
            await goToTalkPage(currCharacterInfo)
        } else {
            if (currCharacterInfo.avatar_type == 2) {
                try {
                    const { data, code } = await getAvatarCommercial(currCharacterInfo.id)
                    if (code == '0') {
                        if (data.ok) {
                            if (currCharacterInfo.is_nsfw) {
                                await nsfwHandle(currCharacterInfo)
                            } else {
                                await goToTalkPage(currCharacterInfo)
                            }
                        } else {
                            setPayDialog(true)
                        }
                    } else {
                        if (currCharacterInfo.is_nsfw) {
                            await nsfwHandle(currCharacterInfo)
                        } else {
                            await goToTalkPage(currCharacterInfo)
                        }

                    }
                } catch (e) {
                    if (currCharacterInfo.is_nsfw) {
                        await nsfwHandle(currCharacterInfo)
                    } else {
                        await goToTalkPage(currCharacterInfo)
                    }
                }
            } else {
                if (currCharacterInfo.is_nsfw) {
                    await nsfwHandle(currCharacterInfo)
                } else {
                    await goToTalkPage(currCharacterInfo)
                }
            }
        }


    }


    useEffect(() => {
        if (sessionStorage.getItem('avatarListId') != "4") {
            history()
        }


        setDataList([])
        setFinished(false)
        currPage.current = 1
        setCharacter();
    }, [])
    useEffect(() => {
        setDataList([])
        if (!value) {
            setLogsValue("")
        }
    }, [value])
    const setCharacter = async () => {
        if (!value) return
        try {
            const params = {
                type: 4,
                limit: pageSize,
                page: currPage.current,
                query: value
            }
            const { code, data } = await getCharactersList(params)
            if (code == 0) {
                history()
                setIsLoading(false)
                total.current = data.count
                isInitLoading.current = false
                setDataList((prevData: any) => [...prevData, ...data.list]);
                dispatch(changeCharacterList(dataList))
                if (data.list.length == 0) {
                    setFinished(true)
                }
            } else {
                setFinished(true)
                total.current = 0
            }

        } catch (e) {
            setFinished(true)
            setIsLoading(false)
            total.current = 0
        }
        if (currPage.current * pageSize >= total.current) {
            setFinished(true)
            // return false;
        }

    }

    const onLoad = async () => {
        console.log("onLoad")
        if (finished || isInitLoading.current) return;

        currPage.current++
        await setCharacter();
    }

    useLayoutEffect(() => {
        document.addEventListener('touchstart', touchStartHandle);
        return () => {
            document.removeEventListener('touchstart', touchStartHandle);
            // window.scrollTo(0, 0);
        }
    })

    const touchStartHandle = useCallback(() => {
        window.scrollTo(0, 1);
        ensureDocumentIsScrollable();
    },[])

    const ensureDocumentIsScrollable = () => {
        const isScrollable = document.documentElement.scrollHeight > window.innerHeight;
        if (!isScrollable) {
            document.documentElement.style.setProperty(
                "height",
                "calc(100vh + 0.5px)",
                "important"
            );
        }
    }
    const deleteHistory = async () => {
        const { code } = await deleteSearchHistory()
        if (code == '0') {
            setSearchHistory([])
        }
    }

    function coinIsNSFW() {
        try {
            postSetting(localStorage.getItem('userId'), { ...settings, ...starType }).then((result: any) => {
                if (result.code == 0) {
                    dispatch(changeSettings({ ...settings, ...starType }))
                    setUserInfo()
                } else if (result.code == '65547') {
                    setText(t("other.attention"))
                    setPromptText('Insufficient $STAR')
                    setDialog(true)
                }
            })
        } catch {
            setText(t("other.attention"))
            setPromptText(t("other.neterror"))
            setDialog(true)
        }

    }



    const setUserInfo = useCallback(async () => {
        const UserInfo = await getUserInfo(localStorage.getItem('address_params'))
        if (UserInfo.code == "0") {
            dispatch(changeUserInfo(UserInfo.data))
        }
    }, [])

    const postCommercial = async () => {
        try {
            const { data, code, msg } = await postAvatarCommercial(payData.id)
            if (code == '0') {
                await goToTalkPage(payData)
            } else {
                setPayDialog(false)
                setText(t("other.attention"))
                setDialog(true)
                setPromptText(msg)
            }
        } catch {
            setPayDialog(false)
        }

    }

    const changeTagHandle = (item: any) => {
        setValue(item)
    }
    const characterDom = useRef<any>(null)
    const swiperRef = useRef<any>(null)
    return (
        <div ref={characterDom} className='search-boxh-full descriptionLogs searchBox w-full box-border overflow-hidden'>
            <div className="h-[44px] flex
             justify-center md:absolute max-md:fixed w-full z-[9] pt-5 px-4 box-border">
                <Back callback={() => { navigate(`/agents?id=${sessionStorage.getItem('avatarListId')}`) }}>
                    <div className="flex-1 h-[44px] relative mr-2">
                        {/* search icon */}
                        <svg className="absolute left-2 top-[14px]" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="10-cards-搜索4" transform="translate(-60.000000, -61.000000)" fill="#A6A6A6" fillRule="nonzero">
                                    <g id="编组-66" transform="translate(16.000000, 54.237154)">
                                        <g id="编组备份" transform="translate(44.000000, 6.762846)">
                                            <path d="M15.8162606,14.916384 L12.8433128,11.9434362 C13.9040342,10.679772 14.5437767,9.05077441 14.5437767,7.27184289 C14.5437767,3.255722 11.2880547,0 7.27193382,0 C3.255722,0 0,3.25563108 0,7.27175197 C0,11.2878729 3.255722,14.5435949 7.27184289,14.5435949 C9.05077441,14.5435949 10.679772,13.9039433 11.9434362,12.8432218 L14.916384,15.8161696 C15.1652699,16.0622097 15.5661334,16.0610673 15.813613,15.8136127 C16.0610926,15.5661581 16.0622755,15.1652948 15.8162606,14.916384 L15.8162606,14.916384 Z M1.27257478,7.27175197 C1.27257478,3.96374857 3.96383949,1.27248386 7.27184289,1.27248386 C10.5798463,1.27248386 13.271111,3.96374857 13.271111,7.27175197 C13.271111,10.5797554 10.5798463,13.2710201 7.27184289,13.2710201 C3.96383949,13.2710201 1.27257478,10.5797554 1.27257478,7.27175197 Z" id="形状"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        {/* clear icon */}

                        <svg onClick={() => { clearHandle() }} className={`absolute right-2 top-[14px] ${value.length ? "" : "hidden"}`} width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="10-cards-搜索4" transform="translate(-276.000000, -61.000000)">
                                    <g id="编组-12备份-2" transform="translate(276.000000, 61.000000)">
                                        <circle id="椭圆形备份-2" fillOpacity="0.804359703" fill="#7F7F7F" cx="8" cy="8" r="8"></circle>
                                        <g id="close备份-2" transform="translate(5.000000, 5.000000)" fillRule="nonzero">
                                            <rect id="矩形" opacity="0" x="0" y="0" width="7" height="7"></rect>
                                            <polygon id="路径" fill="#FFFFFF" points="5.35544156 1.55353843 3.4105707 3.49999664 5.35560345 5.44630031 5.00596784 5.79310345 3.06258094 3.84827796 1.11903216 5.79310345 0.769396552 5.44630031 2.71426741 3.49999664 0.769396552 1.55353171 1.11903216 1.20689655 3.06241906 3.15156078 5.00580595 1.20689655"></polygon>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                        <input type="text" placeholder={t("agent.search.search")} onBlur={() => { setIsFocus(false) }} onFocus={() => { setIsFocus(true) }} value={value} onInput={(e) => { searchHandle(e) }} className='rounded-lg text-sm w-full h-full bg-[#333333] placeholder-[#a6a6a6] text-white outline-none border-none px-8' />
                    </div>

                    <ButtonComp title={t("agent.search.search")} disabled={!value} width={60} height={28} callBack={() => {
                        if (sessionStorage.getItem('avatarListId') != "4") {
                            setDataList([])
                            currPage.current = 1
                            setCharacter();
                            setLogsValue("")
                        } else {
                            setLogsValue(value)
                        }

                    }}>
                    </ButtonComp>
                </Back>
            </div>
            <div className={`h-[100vh] overflow-auto  w-full pt-14 px-4`}>
                {!value && sessionStorage.getItem('avatarListId') != "4" && <div className="search-history pt-4">
                    <div className="title flex items-center">
                        <span className='text-white text-base'>{t("agent.search.search_history")}</span>
                        <svg onClick={deleteHistory} width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                            <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="创建-搜索" transform="translate(-345.000000, -108.000000)" fill="#A6A6A6" fillRule="nonzero">
                                    <g id="编组备份-5" transform="translate(345.000000, 108.000000)">
                                        <path d="M10.7170812,1.99369951 C11.4120222,2.08457884 12.1351682,1.96761162 12.7026209,2.05730336 C13.6215884,2.20255845 14.08739,2.9286197 13.9864304,3.99746427 C13.6155535,3.99746427 13.2447185,3.99746427 12.8737788,3.99746427 C12.8424305,5.89352885 12.8567217,7.77246106 12.8567217,9.67483346 C12.8567217,10.6350239 12.9427825,11.6448397 12.8396226,12.5055457 C12.7420157,13.3192739 12.1004882,13.8148467 11.3161964,13.9368368 C10.542843,14.0571137 9.51658757,13.9686485 8.66310345,13.9686485 C6.87340614,13.9686485 5.05990432,14.0008495 3.30551566,13.9686485 C2.45113049,13.9529373 1.82167285,13.7010139 1.43977382,13.2211718 C1.05783287,12.7413686 1.09743722,12.0152684 1.09743722,11.1538226 C1.09743722,8.75385277 1.09743722,6.37405237 1.09743722,3.99746427 C0.743659365,3.99746427 0.389902439,3.99746427 0.036166501,3.99746427 C-0.136164787,3.01404784 0.322072158,2.30733835 1.09743722,2.0732092 C1.66738357,1.90106802 2.42722121,2.04011261 3.23701483,1.99369951 C3.17163623,0.935173298 3.23320108,0.131081959 4.21270665,0.0217269375 C4.65047087,-0.0271586719 5.23506453,0.0217269375 5.77030992,0.0217269375 C6.73539866,0.0217269375 7.85377088,0.0217269375 8.88562125,0.0217269375 C9.4796026,0.0217269375 10.087456,-0.0315391046 10.3919065,0.212557962 C10.8135356,0.550688294 10.7031463,1.32954833 10.7170812,1.99369951 Z M4.29822266,1.07131708 C4.29822266,1.38937528 4.29822266,1.7074335 4.29822266,2.0254917 C6.08408526,2.0254917 7.86994786,2.0254917 9.65578951,2.0254917 C9.65578951,1.69152765 9.65578951,1.35756363 9.65578951,1.02361906 C7.87566849,1.02361906 6.09546365,1.02361906 4.31532168,1.02361906 C4.29537283,1.02628626 4.29673489,1.04875299 4.29822266,1.07131708 Z M3.25409288,4.10878562 C3.25409288,6.12140859 3.25409288,8.12562113 3.25409288,10.1678169 C3.25409288,10.6853891 3.12601787,11.7881285 3.45949064,12.0125623 C3.59215472,12.1018646 3.93421892,12.1150449 4.0928249,12.0125623 C4.4378437,11.7897638 4.31534265,10.7184078 4.31534265,10.1837227 C4.31534265,8.11526384 4.31534265,6.01947108 4.31534265,4.06106812 C3.96732732,4.06106812 3.61924914,4.06106812 3.27121286,4.06106812 C3.251264,4.06373532 3.25260509,4.08620207 3.25409288,4.10878562 Z M6.43782122,4.10878562 C6.43782122,5.92060964 6.43782122,8.03629927 6.43782122,9.97698584 C6.43782122,10.4399682 6.32204662,11.5358741 6.52340014,11.8535429 C6.6564414,12.0634142 7.10418005,12.1585571 7.32789221,11.9966954 C7.63125311,11.7772066 7.49909194,10.6165871 7.49909194,10.1360441 C7.49909194,8.06234822 7.49909194,6.0731849 7.49909194,4.06110705 C7.15105566,4.06110705 6.80295652,4.06110705 6.45494118,4.06110705 C6.43499234,4.06373532 6.4363544,4.08620207 6.43782122,4.10878562 Z M9.65578951,4.10878562 C9.65578951,6.05881711 9.65578951,8.22944707 9.65578951,10.247346 C9.65578951,10.8760254 9.52387981,11.8403043 9.96388618,12.0125623 C10.1554748,12.0875942 10.4954855,12.0295583 10.5800795,11.9648837 C10.8673472,11.7451613 10.7341802,10.5671564 10.7341802,10.1042325 C10.7341802,8.04099121 10.7341802,6.06236037 10.7341802,4.06110707 C10.3804024,4.06110707 10.0266245,4.06110707 9.6729095,4.06110707 C9.65296063,4.06373532 9.65432269,4.08620207 9.65578951,4.10878562 Z" id="形状"></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </div>
                    <div className="history flex flex-wrap gap-[6px] mt-4 ">
                        {
                            Array.isArray(searchHistory) && searchHistory.map(((item: any) => {
                                return (
                                    <div onClick={() => { changeTagHandle(item) }} key={item.id} className={`${item.id == "-1" ? 'hidden' : ''}  ${item == value ? 'bg-gradient-to-r from-[#00E49F] to-[#54ADFF] text-shadow-lg' : ''} mb-2 h-9 rounded px-[10px] flex justify-center items-center bg-[#333] text-white text-sm`}>
                                        {item}
                                    </div>
                                )
                            }))
                        }
                    </div>
                    <div className="title flex items-center">
                        <span className='text-white text-base'>{t("agent.search.recommended_for_you")}</span>
                    </div>
                    <div className="history flex flex-wrap gap-[6px] mt-4 ">
                        {
                            Array.isArray(tags) && tags.map(((item: any) => {
                                return (
                                    <div onClick={() => { changeTagHandle(item) }} key={item.id} className={`${item.id == "-1" ? 'hidden' : ''}  ${item == value ? 'bg-gradient-to-r from-[#00E49F] to-[#54ADFF] text-shadow-lg' : ''} mb-2 h-9 rounded px-[10px] flex justify-center items-center bg-[#333] text-white text-sm`}>
                                        {item}
                                    </div>
                                )
                            }))
                        }
                    </div>
                </div>}
                {
                    sessionStorage.getItem('avatarListId') == "4" && <Logs searchValue={logsValue}></Logs>
                }
                {sessionStorage.getItem('avatarListId') != "4" && value && dataList.length > 0 && <List className='list w-full flex flex-wrap mt-3 justify-between' finished={finished} loading={isLoading} immediateCheck={false} onLoad={onLoad} loadingText="Loading...">
                    {Array.isArray(dataList) && dataList.map((item: any, i: number) => {
                        return (
                            <div ref={roleRef} key={`dataList ${item.id}`} className={`role min-h-[269px] w-[calc((100%_-_5px)/2)] overflow-hidden rounded-xl mb-[5px] relative  bg-cover bg-center ${(dataList.length % 2 != 0 && i == dataList.length - 1) ? 'mr-auto' : ''}`} >
                                {/* <img className='absolute top-0 left-0 rounded-xl' src={bg} alt="" /> */}
                                {
                                    <img className='w-[23px] z-[2] h-[23px] absolute top-0 left-0' src={attributeImage(item.property)}></img>
                                }
                                {
                                    item.mint_state == 3 && <img className='w-[42px] z-[2] h-[20px] absolute top-[30px] left-[0px]' src={nftImg}></img>
                                }
                                <Swiper indicator={true} style={{ borderRadius: "8px", position: "absolute" }} className='rounded-xl top-0 left-0' autoplay={((Math.random() * 0.4 + 0.15) * (i + 1000) * 45)}>
                                    {item.main_images.map((image: any, ii: number) => (


                                        // <Swiper.Item onClick={(e: any) => { e.stopPropagation(), goToTalk(item) }} key={ii} className='min-h-[269px] w-[calc((100%)] rounded-xl'>
                                        //     <img className='rounded-xl' src={image} alt="" />

                                        //     {
                                        //         (settings.nsfw_pay_type == 2 && !settings.star_nsfw) && item?.main_images_nsfw.length > 0 && item.main_images_nsfw[ii] && <div className='w-[100%] h-[100%] absolute top-0 left-0 flex items-center justify-center !backdrop-blur-[1.25rem] z-1' onClick={(e: any) => {
                                        //             e.stopPropagation()
                                        //             if (!settings.character_nsfw) {
                                        //                 goToTalk(item)
                                        //             } else {
                                        //                 setDataList(dataList.map((el: any, it: number) => {
                                        //                     if (i == it) {
                                        //                         let item = {
                                        //                             ...el
                                        //                         }
                                        //                         item.main_images_nsfw[ii] = !item.main_images_nsfw[ii]
                                        //                         return item
                                        //                     }
                                        //                     else {
                                        //                         return el
                                        //                     }

                                        //                 }))
                                        //             }


                                        //         }}>
                                        //             <img src={show} alt="" />
                                        //         </div>
                                        //     }

                                        // </Swiper.Item>
                                        <Swiper.Item onClick={(e: any) => { e.stopPropagation(), goToTalk(item) }} key={ii} className='min-h-[269px] w-[calc((100%)] rounded-xl'>
                                            <img className='rounded-xl' ref={swiperRef} src={image} alt="" />
                                            {
                                                !settings.star_nsfw && !item.is_my && item?.main_images_nsfw.length > 0 && item?.main_images_nsfw[ii] && <GlassmorphismCanvas
                                                    imageUrl={image}
                                                    x={0}
                                                    y={0}
                                                    width={swiperRef.current?.getBoundingClientRect().width || 188}
                                                    height={swiperRef.current?.getBoundingClientRect().height || 269}
                                                    blurRadius={40}
                                                    zIndex={0}
                                                    index={ii}
                                                />
                                            }
                                            {
                                                (!settings.star_nsfw) && !item.is_my && item?.main_images_nsfw.length > 0 && item?.main_images_nsfw[ii] && <div className='w-[100%] h-[100%] absolute top-0 left-0 flex items-center justify-center !backdrop-blur-[1.25rem] z-1' onClick={(e: any) => {
                                                    e.stopPropagation()
                                                    goToTalk(item)
                                                }}>
                                                    <img onClick={(event) => {
                                                        event.stopPropagation()
                                                        if (settings.nsfw_pay_type != 0 || settings.nsfw) {
                                                            setDataList(dataList.map((el: any, it: number) => {
                                                                if (el.id == item.id) {
                                                                    let obj = JSON.parse(JSON.stringify(el))
                                                                    if (obj.main_images_nsfw[ii]) {
                                                                        obj.main_images_nsfw[ii] = !obj.main_images_nsfw[ii]
                                                                    }
                                                                    return obj
                                                                }
                                                                return el;
                                                            }))
                                                        } else {
                                                            setStateType({ character_nsfw: true })
                                                            setCoin_NSFW(true)
                                                        }

                                                    }} src={show} alt="" />
                                                </div>
                                            }

                                        </Swiper.Item>
                                    ))}
                                </Swiper>
                                <div className="info absolute bottom-0 px-3 py-2 box-border left-0 w-full h-[100px] bg-gradient-to-t from-[#454545] to-[#000]/[0] rounded-r-xl rounded-l-xl">
                                    <div onClick={() => { goToTalk(item) }} className="font-bold text-base text-white">{item.name}</div>
                                    <div onClick={() => { goToTalk(item) }} className="options w-full h-7 flex">
                                        {/*  点赞 */}
                                        <div className='flex items-center'>
                                            <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="02-talk平铺" transform="translate(-26.000000, -256.000000)" fill="#E0E0E0" fillRule="nonzero">
                                                        <g id="编组-12" transform="translate(16.000000, 213.000000)">
                                                            <g id="编组-11" transform="translate(10.000000, 41.000000)">
                                                                <g id="编组备份-14" transform="translate(0.000000, 2.000000)">
                                                                    <path d="M8.21868721,0.0401908054 C9.22610184,-0.121578513 10.1720156,0.207559831 10.9376267,0.98125273 C11.715538,1.76770052 12.0884434,2.80395747 11.9822419,3.89092289 C11.8772403,4.96482233 11.3276324,6.02534468 10.4027189,6.96018472 C10.1447152,7.2211933 9.45110512,7.92582315 8.45569067,8.93812579 C8.00808417,9.39356865 7.53167724,9.87794334 7.05167028,10.3669844 L6.58486349,10.8417152 L6.3994608,11.0305498 C6.17760519,11.2564834 5.8221048,11.2564834 5.6002492,11.0305498 L3.98862579,9.38796894 L3.64812085,9.04203146 C2.9645117,8.34797578 2.28080177,7.65402686 1.59699106,6.96018472 C0.672077627,6.02534468 0.122769655,4.96513342 0.0177681253,3.89092289 C-0.0884334169,2.80395747 0.284171994,1.76770052 1.0623833,0.98125273 C1.82799442,0.207559831 2.77390816,-0.121267423 3.78132278,0.0401908054 C4.52893364,0.159962319 5.28734465,0.546031036 6.000155,1.16230993 C6.71326535,0.546342126 7.47137637,0.159962319 8.21898723,0.0401908054 L8.21868721,0.0401908054 Z" id="路径"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <div className='ml-1 text-xs text-[#e0e0e0]'>{item.like_count}</div>


                                        </div>
                                        {/* 交互 */}

                                        <div className='flex items-center ml-3'>
                                            <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

                                                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                    <g id="02-talk平铺" transform="translate(-64.000000, -255.000000)" fill="#E0E0E0" fillRule="nonzero">
                                                        <g id="编组-12" transform="translate(16.000000, 213.000000)">
                                                            <g id="编组-11" transform="translate(10.000000, 41.000000)">
                                                                <g id="编组备份-13" transform="translate(38.000000, 1.000000)">
                                                                    <path d="M11.5239457,3.42134657 C11.2161611,2.7466612 10.7767079,2.1399395 10.2312596,1.63662729 C9.68247157,1.12220127 9.04171997,0.715207345 8.34233458,0.436816014 C6.84395033,-0.145605338 5.18103645,-0.145605338 3.6826522,0.436816014 C2.97615232,0.712982518 2.32842877,1.12008551 1.77368555,1.63662729 C1.23594722,2.14222152 0.803473534,2.74870995 0.501041122,3.42134657 C0.178294404,4.10860716 0.00741922747,4.85707272 0,5.61600137 C0.00821477146,6.99708519 0.546071031,8.32262114 1.50312335,9.3204187 L1.77368555,11.6250562 C1.79898275,11.8381332 1.97951517,11.9989627 2.19456009,12 C2.26829417,12.0001518 2.34080535,11.9812032 2.40499735,11.9450059 L4.14862044,10.9451631 C5.52973447,11.3649235 7.01226158,11.3085725 8.35736582,10.7851883 C9.06386569,10.5090218 9.71158924,10.1019188 10.2663325,9.58537702 C10.7970641,9.08283239 11.2242718,8.48166296 11.5239457,7.81565538 C12.1586848,6.41934278 12.1586848,4.81765917 11.5239457,3.42134657 Z M3.40707958,6.27089836 C3.05011418,6.27089836 2.76073656,5.98216743 2.76073656,5.62599979 C2.76073656,5.26983215 3.0501142,4.98110124 3.4070796,4.98110124 C3.764045,4.98110124 4.0534227,5.26983216 4.0534227,5.6259998 C4.05359058,5.97450211 3.77623622,6.26009212 3.42712123,6.27089836 L3.40707958,6.27089836 Z M5.99245174,6.27089836 C5.63548634,6.27089836 5.34610872,5.98216743 5.34610872,5.62599979 C5.34610872,5.26983215 5.63548636,4.98110124 5.99245176,4.98110124 C6.34941716,4.98110124 6.63879486,5.26983216 6.63879486,5.6259998 C6.63896274,5.97450211 6.36160838,6.26009212 6.01249339,6.27089836 L5.99245174,6.27089836 Z M8.5778239,6.27089836 C8.2208585,6.27089836 7.93148088,5.98216743 7.93148088,5.62599979 C7.93148088,5.26983215 8.22085852,4.98110124 8.57782391,4.98110124 C8.93478931,4.98110124 9.22416697,5.26983216 9.22416697,5.6259998 C9.22426192,5.97639176 8.94393696,6.26274972 8.59285513,6.27089836 L8.5778239,6.27089836 Z" id="形状"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <div className='ml-1 text-xs text-[#e0e0e0]'>{item.chat_count}</div>
                                        </div>
                                    </div>
                                    <Popover
                                        ref={popover}
                                        placement={i % 2 == 1 ? 'bottom-end' : 'bottom-start'}
                                        theme='dark'
                                        teleport={characterDom.current}
                                        reference={<div className='text-xs z-10 text-white h-8 line-clamp-2'>{item.description}</div>}
                                    >
                                        <div style={{ textShadow: '0px 2px 4px rgba(0,0,0,0.5)' }} className='text-[14px] w-[285px] p-[10px] leading-[18px] text-[#ffffff]'>{item.description}</div>
                                    </Popover>
                                </div>

                                {/* <img className={`${item.is_nsfw ? '' : 'hidden'} absolute z-[3] w-10`} src={nsfw} alt="" /> */}

                            </div>
                        )
                    })}

                </List>}

                <PromptDialog
                    title={t("agent.create.warning")}
                    dialog={coin_NSFW}
                    price='1,000,000'
                    is_Stars='coin'
                    setDialog={setCoin_NSFW}
                    text_mt={30}
                    text={t("agent.search.text")}
                    text_1={t("agent.search.do_you_want_to_proceed")}
                    callback={coinIsNSFW}
                ></PromptDialog>
                <PromptDialog
                    title={t("other.attention")}
                    dialog={payDialog}
                    setDialog={setPayDialog}
                    text={`${t("agent.search.created_by")} @${payData?.account_name ? payData?.account_name : payData?.account_id}. ${t("agent.search.a_one_time_fee_of")} ${FormattingNumber(payData?.price.toString())} ${t("agent.search.star_is_required")}`}
                    isClose={true}
                    callback={
                        postCommercial
                    }
                ></PromptDialog>
            </div>

        </div >
    )
}


export default Search;
